<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">


                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                                    to="/adesao-plano" v-on="on" v-bind="attrs">
                                    Voltar
                                </v-btn>
                            </template>
                            <span>Voltar para a listagem</span>
                        </v-tooltip>
                    </div>

                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined">
                            <v-card-title class="card-group-title">Detalhes credor</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Nome" :value="dataset.data.user.name" outlined
                                            hide-details="auto" disabled />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="CPF/CNPJ" :value="formattedRegistration" outlined
                                            hide-details="auto" disabled />
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Email" :value="dataset.data.user.email" outlined
                                            hide-details="auto" disabled />
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Telefone" :value="dataset.data.user.phone_number"
                                            outlined hide-details="auto" disabled />
                                    </v-col>
                                </v-row>
                                <v-row v-if="dataset.data && dataset.data.type">
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Classe" :value="getCreditorTypeName(dataset.data.type)" outlined
                                            hide-details="auto" disabled />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field dense label="Opção Pagamento" :value="getPlanOptionText(dataset.data.type, dataset.data.plan_option)" outlined
                                            hide-details="auto" disabled />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>

                <v-row v-if="dataset.data && dataset.data.name_audit_status === 'mismatch'" class="mt-0">
                    <v-col cols="12">
                        <v-alert dense outlined color="warning" icon="mdi-alert-outline" class="mb-0">
                            <div class="font-weight-bold mb-2">Divergência de nome identificada</div>
                            <div v-if="dataset.data.name_audit_details_parsed">
                                <div>
                                    <strong>Nome no momento da geração:</strong>
                                    {{ dataset.data.name_audit_details_parsed.generated_creditor_name || 'N/A' }}
                                </div>
                                <div>
                                    <strong>Nome atual do cadastro:</strong>
                                    {{ dataset.data.name_audit_details_parsed.current_creditor_name || 'N/A' }}
                                </div>
                                <div>
                                    <strong>Nome no termo:</strong>
                                    {{ dataset.data.name_audit_details_parsed.term_creditor_name || 'N/A' }}
                                </div>
                                <div>
                                    <strong>Nome da assinatura:</strong>
                                    {{ dataset.data.name_audit_details_parsed.validated_signature_name || 'N/A' }}
                                </div>
                            </div>
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row v-if="dataset.data && dataset.data.uploaded_doc" class="mt-4">
                    <v-col cols="12">
                        <v-card flat outlined class="pa-4">
                            <h3 class="mb-4">Detalhes assinatura digital</h3>
                            <v-card class="mb-4 pa-3" flat outlined>
                                <v-row>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Nome:</strong> {{ dataset.data.signer_name || '' }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Email:</strong> {{ dataset.data.signer_email || '' }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>CPF/CNPJ:</strong> {{ formatCpfCnpj (dataset.data.signer_registration) || '' }}
                                        </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Certificado válido de:</strong> {{ dataset.data.cert_valid_from |
                                            defaultDate('DD/MM/YYYY HH:mm:ss') }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Certificado válido até:</strong> {{ dataset.data.cert_valid_to |
                                            defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Enviado em:</strong> {{ dataset.data.uploaded_at |
                                            defaultDate('DD/MM/YYYY HH:mm:ss') }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Resultado:</strong> {{ dataset.data.validation_result || ''
                                            }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span><strong>Status:</strong></span>
                                        <v-chip class="ml-2" :color="getStatusColor(dataset.data.status)"
                                            text-color="white" small>
                                            {{ getStatusText(dataset.data.status) }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <br>
                            </v-card>

                            <v-card v-if="dataset.data && dataset.data.issuerDetails" class="mb-4 pa-3" flat outlined>
                                <!-- <h4 class="mb-2">Emissor:</h4> -->
                                <v-row>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>País:</strong> {{ dataset.data.issuerDetails.c || '' }} </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Emissor:</strong> {{ dataset.data.issuerDetails.cn || '' }}
                                        </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Organização:</strong> {{ dataset.data.issuerDetails.o || '' }}
                                        </span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center mb-n5">
                                        <span> <strong>Unidade:</strong> {{ dataset.data.issuerDetails.ou || '' }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <br>
                            </v-card>

                            <v-alert v-else type="info" color="warning" outlined icon="mdi-clock-outline">
                                <template v-slot:prepend>
                                    <v-icon color="grey darken-4">mdi-clock-outline</v-icon>
                                </template>
                                <span class="text--primary ml-3">O credor ainda não enviou arquivo assinado.</span>
                            </v-alert>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined">
                            <v-card-title class="card-group-title">Detalhes documento</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col v-if="dataset.data && dataset.data.generated_doc" class="doc-info" cols="12"
                                        sm="3">
                                        <span>Documento PDF - Gerado</span>
                                    </v-col>
                                    <v-col v-if="dataset.data && dataset.data.uploaded_doc" class="doc-info" cols="12"
                                        sm="3">
                                        <span>Documento PDF - Assinado</span>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="3">
                                        <iframe
                                            :src="typeof dataset.data.generated_doc_url === 'string' ? dataset.data.generated_doc_url : null"
                                            width="250" height="150" frameborder="0" scrolling="no" class="rounded-xl">
                                        </iframe>
                                    </v-col>

                                    <v-col cols="12" sm="3">
                                        <iframe
                                            :src="typeof dataset.data.uploaded_doc_url === 'string' ? dataset.data.uploaded_doc_url : null"
                                            width="250" height="150" frameborder="0" scrolling="no" class="rounded-xl">
                                        </iframe>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col v-if="dataset.data && dataset.data.generated_doc" cols="12" sm="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="typeof dataset.data.generated_doc_url === 'string' ? dataset.data.generated_doc_url : null"
                                            target="_blank">
                                            Visualizar documento
                                        </v-btn>
                                    </v-col>

                                    <v-col v-if="dataset.data && dataset.data.uploaded_doc" cols="12" sm="3">
                                        <v-btn type="button" elevation="0" color="primary" outlined
                                            :href="typeof dataset.data.uploaded_doc_url === 'string' ? dataset.data.uploaded_doc_url : null"
                                            target="_blank">
                                            Visualizar documento
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>



    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"
import creditorTypes from "@/common/data/creditor-types.data"

import axios from "axios"

import { cpf, cnpj } from 'cpf-cnpj-validator'

export default {
    name: "PlanAdherenceDetails",
   
    data: () => ({
        user: null,
        page: {
            isNew: false,
            title: "",
        },
        planOptionText: {
            1: [
                { text: 'OPÇÃO A', value: 1 },
            ],
            3: [
                { text: 'OPÇÃO A', value: 1 },
                { text: 'OPÇÃO B', value: 2 },
                { text: 'OPÇÃO C', value: 3 },
                { text: 'OPÇÃO D', value: 4 },
                { text: 'OPÇÃO E', value: 5 },
            ],
            4: [
                { text: 'OPÇÃO A', value: 1 },
                { text: 'OPÇÃO B', value: 2 },
            ],
        },
        dataset: {
            creditorTypes: creditorTypes,
            breadcrumbItems: [],
            data: {
                user: {
                    name: '',
                    registrtration: '',
                },
            
                issuerDetails: '',
                
            },
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
       
    }),

    computed: {
        formattedRegistration() {
            const registration = this.dataset.data.user.registration;
            if (!registration) return '';

            return registration.length < 14
            ? cpf.format(registration)
            : cnpj.format(registration);
        }
    },

    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/adesao-plano");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            this.user = this.$root.user.data || this.$root.user;
            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Nova Adesão ao Plano' : 'Detalhes da Adesão ao Plano'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Adesão ao plano",
                disabled: false,
                to: "/adesao-plano",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        formatCpfCnpj(value) {

            return value.length < 14 ? cpf.format(value) : cnpj.format(value);
        },

        getCreditorTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(item => item.id === typeId);
            return type ? type.name : 'N/A';
        },
        
        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/plan-adherence/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

               this.dataset.data.issuerDetails = JSON.parse(data.cert_issuer_details);

               console.log("issuer: ", this.dataset.data.issuerDetails)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        getPlanOptionText(type, planOption) {
            if (!type || !planOption) return 'N/A';

            const optionsByType = this.planOptionText[type];
            if (!optionsByType) return 'N/A';

            const option = optionsByType.find(opt => opt.value === planOption);
            return option ? option.text : 'N/A';
        },

        getStatusText(status) {
            switch (status) {
            case 0:
                return 'Pendente';
            case 1:
                return 'Aprovado';
            case 2:
                return 'Rejeitado';
            default:
                return 'Desconhecido';
            }
        },

        getStatusColor(status) {
            switch (status) {
            case 0:
                return 'orange';
            case 1:
                return 'green';
            case 2:
                return 'red';
            default:
                return 'grey';
            }
        },
    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
